import VillaListFilters from './VillaListFilters';

export default VillaListFilters;
